var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09581 13.8548V11.8102C6.0958 11.2921 6.5171 10.8711 7.03895 10.8679H8.95506C9.47924 10.8679 9.90417 11.2898 9.90417 11.8102V13.8488C9.90416 14.2982 10.2693 14.6634 10.7219 14.6667H12.0292C12.6397 14.6682 13.2258 14.4285 13.6581 14.0005C14.0904 13.5724 14.3333 12.9912 14.3333 12.385V6.57724C14.3333 6.0876 14.1147 5.62315 13.7364 5.30901L9.29531 1.78286C8.519 1.16609 7.41024 1.18602 6.65692 1.83027L2.31133 5.30901C1.91515 5.61389 1.67836 6.07972 1.66666 6.57724V12.3791C1.66666 13.6425 2.69824 14.6667 3.97077 14.6667H5.24818C5.4661 14.6682 5.67565 14.5834 5.8303 14.431C5.98496 14.2785 6.07194 14.0711 6.07193 13.8548H6.09581Z",
    fill: "#5570F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.dfdacfa174478172faaf99fbb349baca.svg";
export { ForwardRef as ReactComponent };